module.exports = __webpack_public_path__ + "static/media/ticke249914e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/tick.svg
// module id = 1495
// module chunks = 0